// Formatos e rotulos das comissoes (#1518). Valores chegam em centavos inteiros.

export const formatarCentavos = (centavos) => {
    const n = Number(centavos) || 0;
    const valor = (Math.abs(n) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${n < 0 ? '- ' : ''}R$ ${valor}`;
};

// "2026-11-09" ou "2026-11-09 10:00:00" sem passar por Date (evita trocar o dia pelo fuso).
export const formatarData = (valor) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(valor || ''));
    return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
};

export const formatarDataHora = (valor) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(String(valor || ''));
    return m ? `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}` : formatarData(valor);
};

export const hojeISO = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export const SITUACOES = {
    a_pagar: {
        label: 'A pagar',
        cor: 'orange',
        explicacao: 'Comissão apurada e ainda não paga ao vendedor.',
    },
    paga: {
        label: 'Paga',
        cor: 'green',
        explicacao: 'Comissão já paga ao vendedor. O valor pago fica congelado; para alterar, um administrador desfaz o pagamento na aba Pagamentos.',
    },
    fora: {
        label: 'Fora da rastreabilidade',
        cor: 'gray',
        explicacao: 'Venda de antes de 01/11/2026, quando o controle de pagamento começou. Não entra na conta automaticamente: um administrador pode marcar como paga ou mover para "A pagar".',
    },
    sem_valor: {
        label: 'Sem comissão',
        cor: 'gray',
        explicacao: 'A comissão desta venda ficou zerada (itens cancelados ou devolvidos).',
    },
    cancelada: {
        label: 'Cancelada',
        cor: 'red',
        explicacao: 'Venda cancelada: não gera comissão.',
    },
};

export const SITUACOES_SITE = {
    ok: { label: 'Site atualizado', cor: 'green', explicacao: 'O Sistema de Parceiros do site confirmou.' },
    pendente: { label: 'Enviando ao site', cor: 'yellow', explicacao: 'Aguardando o envio ao Sistema de Parceiros do site.' },
    erro: { label: 'Site: nova tentativa', cor: 'orange', explicacao: 'O site não respondeu. O sistema tenta de novo sozinho a cada poucos minutos.' },
    recusado: { label: 'Site recusou', cor: 'red', explicacao: 'O site recusou por regra (ex.: comissão cancelada ou em pedido de saque). Confira e use "Reenviar ao site".' },
    nao_aplica: { label: 'Sem comissão no site', cor: 'gray', explicacao: 'Venda sem o link de parceiro do vendedor: não existe comissão dela no site.' },
};

export const FORMAS_PAGAMENTO = [
    { value: 'pix', label: 'PIX' },
    { value: 'transferencia', label: 'Transferência' },
    { value: 'dinheiro', label: 'Dinheiro' },
    { value: 'outro', label: 'Outro' },
];

export const mensagemErro = (e, padrao) => e?.response?.data?.error || padrao;
